import React, { useMemo, useEffect, useState, memo } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { useToasts } from 'react-toast-notifications'
import axiosInstance from '../../../../../services/config/AxiosIntance'

import Table from '../../../../../components/Table'
import Loader from '../../../../../components/Loader'
import Flex from '../../../../../components/layouts/Flex'
import DashboardItemTitle from '../../components/DashboardItemTitle'
import NoData from '../../components/NoData'
import CSVDownloader from '../../../../../lib/CSVDownloader'

const SourcingChannelEffectiveness = () => {
  const { addToast } = useToasts()
  const filters = useSelector((state) => state.dashboard.filters)

  const [totalPage, setTotalPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [loading, setLoading] = useState(false)
  const [tableData, setTableData] = useState([])

  useEffect(() => {
    fetchData()
  }, [filters, currentPage, pageSize])

  const fetchData = async () => {
    try {
      setLoading(true)
      const queryParams = new URLSearchParams(filters).toString()
      const fetchedPageUrl = `/interview/sourcing-channel-effectiveness/fetchPage?${queryParams}&pageNumber=${currentPage}&pageSize=${pageSize}`

      const result = await axiosInstance.get(fetchedPageUrl)
      setTableData(result?.data?.data || [])

      setTotalPage(result?.data?.pagination?.pageCount || 1)
      setRowCount(result?.data?.pagination?.rowCount || 0)
      setCurrentPage(result?.data?.pagination?.page || 1)
      setPageSize(result?.data?.pagination?.pageSize || 10)
    } catch (error) {
      addToast('Something went wrong while fetching sourcing channel effectiveness data', {
        appearance: 'error',
        autoDismiss: true,
      })
    } finally {
      setLoading(false)
    }
  }

  const handleExport = async () => {
    try {
      const queryFilter = {
        ...filters,
        dates: filters?.dates?.toString(),
      }
      const queryParams = new URLSearchParams(queryFilter).toString()
      const url = `/interview/sourcing-channel-effectiveness/fetchAll?${queryParams}&pageNumber=${currentPage}&pageSize=${pageSize}`
      const result = await axiosInstance.get(url)

      const response = result?.data?.data.map((e) => ({
        Channel: e.channel,
        'No. of candidates': e.candidates,
        'No. of hires': e.hires,
        Open: e.open,
        'Conversion Rate (%)': e.conversion_rate,
      }))

      CSVDownloader.downloadUnparsedCSV(
        response,
        'Sourcing_Channel_Effectiveness_report.csv'
      )
    } catch (error) {
      addToast('Something went wrong during export', {
        appearance: 'error',
        autoDismiss: true,
      })
    }
  }

  // ✅ Add full columns here
  const tableColumns = useMemo(
    () => [
      { Header: 'Channel', accessor: 'channel' },
      { Header: 'No. of Candidates', accessor: 'candidates' },
      { Header: 'No. of Hires', accessor: 'hires' },
      { Header: 'Open', accessor: 'open' },
      { Header: 'Conversion Rate (%)', accessor: 'conversion_rate' },
    ],
    []
  )

  return (
    <StyledSourcingChannelEffectiveness>
      <Flex justify="space-between">
        <DashboardItemTitle title="Sourcing Channel Effectiveness List" />
        <Flex gap="0.5rem">
          <ExportButton onClick={handleExport}>Export</ExportButton>
        </Flex>
      </Flex>

      {loading && <Loader />}

      {tableData?.length > 0 ? (
        <Table
          height="100%"
          totalPage={totalPage}
          currentPage={currentPage}
          pageSize={pageSize}
          rowCount={rowCount}
          data={tableData}
          columns={tableColumns}
          setNewPageSize={setPageSize}
          setCurrentPage={setCurrentPage}
          fetchData={fetchData}
          onClick={() => null}
        />
      ) : (
        <NoData />
      )}
    </StyledSourcingChannelEffectiveness>
  )
}

export default memo(SourcingChannelEffectiveness)

const StyledSourcingChannelEffectiveness = styled.div`
  width: 100%;
  height: 100%;
`

const ExportButton = styled.button`
  padding: 0.35rem 0.65rem;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
  text-overflow: ellipsis;
  overflow: hidden;
  background-color: black;
  color: white;
  border-radius: 100px;
  word-spacing: 3px;
`